import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ResponsiveBar } from '@nivo/bar';
import React from 'react';
import { Box } from '../../../UI';

const MyResponsiveBar = () => (
	<Box>
		<ExpansionPanel defaultExpanded={true}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Cash on Cash Graph</strong>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails style={{ height: '297px' }}>
				<ResponsiveBar
					data={data}
					keys={['levered', 'unlevered']}
					indexBy="year"
					margin={{ top: 30, right: 100, bottom: 50, left: 60 }}
					padding={0.3}
					groupMode="grouped"
					colors={['#5c7dca', '#ff7f41']}
					borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
					axisTop={null}
					axisRight={null}
					axisBottom={{
						tickSize: 5,
						tickPadding: 5,
						tickRotation: 0,
						legend: 'Year',
						legendPosition: 'middle',
						legendOffset: 32,
					}}
					axisLeft={{
						tickSize: 5,
						tickPadding: 5,
						tickRotation: 0,
						legend: '%',
						legendPosition: 'middle',
						legendOffset: -40,
					}}
					labelSkipWidth={12}
					labelSkipHeight={12}
					labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
					legends={[
						{
							dataFrom: 'keys',
							anchor: 'bottom-right',
							direction: 'column',
							justify: false,
							translateX: 120,
							translateY: 0,
							itemsSpacing: 2,
							itemWidth: 100,
							itemHeight: 20,
							itemDirection: 'left-to-right',
							itemOpacity: 0.85,
							symbolSize: 20,
							effects: [
								{
									on: 'hover',
									style: {
										itemOpacity: 1,
									},
								},
							],
						},
					]}
					animate={true}
					motionStiffness={90}
					motionDamping={15}
					enableLabel={false}
				/>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	</Box>
);

const data = [
	{
		year: '2020',
		levered: 4.27,
		leveredColor: '#5c7dca',
		unlevered: 3.2,
		unleveredColor: '#ff7f41',
	},
	{
		year: '2021',
		levered: 4.53,
		leveredColor: '#5c7dca',
		unlevered: 3.27,
		unleveredColor: '#ff7f41',
	},
	{
		year: '2022',
		levered: 4.79,
		leveredColor: '#5c7dca',
		unlevered: 3.33,
		unleveredColor: '#ff7f41',
	},
	{
		year: '2023',
		levered: 5.07,
		leveredColor: '#5c7dca',
		unlevered: 3.4,
		unleveredColor: '#ff7f41',
	},
	{
		year: '2024',
		levered: 5.34,
		leveredColor: '#5c7dca',
		unlevered: 3.47,
		unleveredColor: '#ff7f41',
	},
	{
		year: '2025',
		levered: 5.62,
		leveredColor: '#5c7dca',
		unlevered: 3.54,
		unleveredColor: '#ff7f41',
	},
];

// const data = [
// 	{
// 		country: 'AD',
// 		'hot dog': 39,
// 		'hot dogColor': 'hsl(8, 70%, 50%)',
// 		burger: 108,
// 		burgerColor: 'hsl(173, 70%, 50%)',
// 		sandwich: 30,
// 		sandwichColor: 'hsl(295, 70%, 50%)',
// 		kebab: 82,
// 		kebabColor: 'hsl(129, 70%, 50%)',
// 		fries: 120,
// 		friesColor: 'hsl(282, 70%, 50%)',
// 		donut: 49,
// 		donutColor: 'hsl(60, 70%, 50%)',
// 	},
// 	{
// 		country: 'AE',
// 		'hot dog': 79,
// 		'hot dogColor': 'hsl(131, 70%, 50%)',
// 		burger: 160,
// 		burgerColor: 'hsl(108, 70%, 50%)',
// 		sandwich: 59,
// 		sandwichColor: 'hsl(291, 70%, 50%)',
// 		kebab: 101,
// 		kebabColor: 'hsl(245, 70%, 50%)',
// 		fries: 184,
// 		friesColor: 'hsl(83, 70%, 50%)',
// 		donut: 144,
// 		donutColor: 'hsl(25, 70%, 50%)',
// 	},
// 	{
// 		country: 'AF',
// 		'hot dog': 129,
// 		'hot dogColor': 'hsl(92, 70%, 50%)',
// 		burger: 148,
// 		burgerColor: 'hsl(192, 70%, 50%)',
// 		sandwich: 161,
// 		sandwichColor: 'hsl(259, 70%, 50%)',
// 		kebab: 129,
// 		kebabColor: 'hsl(64, 70%, 50%)',
// 		fries: 159,
// 		friesColor: 'hsl(193, 70%, 50%)',
// 		donut: 27,
// 		donutColor: 'hsl(22, 70%, 50%)',
// 	},
// 	{
// 		country: 'AG',
// 		'hot dog': 43,
// 		'hot dogColor': 'hsl(130, 70%, 50%)',
// 		burger: 103,
// 		burgerColor: 'hsl(340, 70%, 50%)',
// 		sandwich: 141,
// 		sandwichColor: 'hsl(252, 70%, 50%)',
// 		kebab: 82,
// 		kebabColor: 'hsl(180, 70%, 50%)',
// 		fries: 55,
// 		friesColor: 'hsl(31, 70%, 50%)',
// 		donut: 40,
// 		donutColor: 'hsl(249, 70%, 50%)',
// 	},
// 	{
// 		country: 'AI',
// 		'hot dog': 13,
// 		'hot dogColor': 'hsl(176, 70%, 50%)',
// 		burger: 34,
// 		burgerColor: 'hsl(6, 70%, 50%)',
// 		sandwich: 28,
// 		sandwichColor: 'hsl(12, 70%, 50%)',
// 		kebab: 79,
// 		kebabColor: 'hsl(73, 70%, 50%)',
// 		fries: 25,
// 		friesColor: 'hsl(324, 70%, 50%)',
// 		donut: 47,
// 		donutColor: 'hsl(53, 70%, 50%)',
// 	},
// 	{
// 		country: 'AL',
// 		'hot dog': 69,
// 		'hot dogColor': 'hsl(110, 70%, 50%)',
// 		burger: 61,
// 		burgerColor: 'hsl(86, 70%, 50%)',
// 		sandwich: 140,
// 		sandwichColor: 'hsl(130, 70%, 50%)',
// 		kebab: 146,
// 		kebabColor: 'hsl(72, 70%, 50%)',
// 		fries: 174,
// 		friesColor: 'hsl(276, 70%, 50%)',
// 		donut: 53,
// 		donutColor: 'hsl(113, 70%, 50%)',
// 	},
// 	{
// 		country: 'AM',
// 		'hot dog': 176,
// 		'hot dogColor': 'hsl(145, 70%, 50%)',
// 		burger: 109,
// 		burgerColor: 'hsl(343, 70%, 50%)',
// 		sandwich: 104,
// 		sandwichColor: 'hsl(28, 70%, 50%)',
// 		kebab: 7,
// 		kebabColor: 'hsl(73, 70%, 50%)',
// 		fries: 39,
// 		friesColor: 'hsl(104, 70%, 50%)',
// 		donut: 18,
// 		donutColor: 'hsl(15, 70%, 50%)',
// 	},
// ];
export default MyResponsiveBar;
